import { FC } from "react";
import { useTranslation } from "react-i18next";

export const RebuildRouteDropdownCustomRebuildHeading: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="rebuild-route-dropdown-custom-rebuild-heading">
      {t("general.REBUILD_ROUTE_CUSTOM_REBUILD_SECTION")}
    </div>
  );
};
